
import React, {Component} from "react";
import * as style from "./style.scss";
import {FlatIcon} from "../Icon/index.js";

export default class Widget extends Component {

    render() {
        return (
            <div className={[style.widget, this.props.className].join(' ')}>
                <div className={style.box}>
                    {this.props.title !== null ? (<div className={style.title}>
                        {this.props.icon !== null ? <FlatIcon icon={this.props.icon}/> : null}
                        {this.props.title}</div>) : null}
                    <div className={style.body}>
                        {this.props.children}
                    </div>
                </div>
            </div>
        )
    }
}
